export const Storage = {
  get: (key: string) => {
    try {
      const item = sessionStorage.getItem(key);
      return item ? JSON.parse(item) : null;
    } catch (error) {
      console.error("Error getting item from sessionStorage:", error);
      return null;
    }
  },

  set: (key: string, value: string) => {
    try {
      sessionStorage.setItem(key, JSON.stringify(value));
      localStorage.setItem(key, JSON.stringify(value));
      return true;
    } catch (error) {
      console.error("Error setting item in sessionStorage:", error);
      return false;
    }
  },

  delete: (key: string) => {
    try {
      sessionStorage.removeItem(key);
      localStorage.removeItem(key);
      return true;
    } catch (error) {
      console.error("Error deleting item from sessionStorage:", error);
      return false;
    }
  },
};
